import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { graphql } from "@/shared/gql";
import { createPlanPrices, type PlanPrices } from "../lib/plan-prices";

export const PlanPricesQuery = graphql(`
  query PlanPrices {
    planPrices {
      plan
      cardPrices {
        term
        monthlyAmountCents
      }
      terms {
        term
        monthlyAmountCents
        invoiceAmountCents
      }
    }
  }
`);

export const usePlanPrices = (): PlanPrices => {
  const { data } = useQuery(PlanPricesQuery, { fetchPolicy: "cache-first" });

  return useMemo(() => createPlanPrices(data?.planPrices ?? []), [data]);
};
